module.exports = __webpack_public_path__ + "static/media/freshpaint1.37a66763.jpg";